import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiMomentCreatorsVariables = Types.Exact<{
  momentId: Types.Scalars['Int'];
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiMomentCreators = { momentCreators: { totalItems: number, page: number, totalPages: number, items: Array<{ profileImageUrl: string | null, username: string | null, name: string | null, publicKey: Address }> } };



export const ApiMomentCreatorsDocument = /*#__PURE__*/ `
    query MomentCreators($momentId: Int!, $page: Int, $perPage: Int) {
  momentCreators(momentId: $momentId, page: $page, perPage: $perPage) {
    items {
      publicKey: accountAddress
      profileImageUrl
      username
      name
    }
    totalItems
    page
    totalPages
  }
}
    `;

export const useMomentCreators = <
      TData = ApiMomentCreators,
      TError = ClientError
    >(
      variables: ApiMomentCreatorsVariables,
      options?: Omit<UseQueryOptions<ApiMomentCreators, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiMomentCreators, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiMomentCreators, TError, TData>(
      {
    queryKey: ['MomentCreators', variables],
    queryFn: apiFetcher<ApiMomentCreators, ApiMomentCreatorsVariables>(ApiMomentCreatorsDocument, variables),
    ...options
  }
    )};

useMomentCreators.getKey = (variables: ApiMomentCreatorsVariables) => ['MomentCreators', variables];

export const useInfiniteMomentCreators = <
      TData = InfiniteData<ApiMomentCreators>,
      TError = ClientError
    >(
      variables: ApiMomentCreatorsVariables,
      options: Omit<UseInfiniteQueryOptions<ApiMomentCreators, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiMomentCreators, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiMomentCreators, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MomentCreators.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiMomentCreators, ApiMomentCreatorsVariables>(ApiMomentCreatorsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMomentCreators.getKey = (variables: ApiMomentCreatorsVariables) => ['MomentCreators.infinite', variables];


useMomentCreators.fetcher = (variables: ApiMomentCreatorsVariables, options?: RequestInit['headers']) => apiFetcher<ApiMomentCreators, ApiMomentCreatorsVariables>(ApiMomentCreatorsDocument, variables, options);
